<template>
    <v-list-item three-line>
        <v-list-item-content class="overflow-visible">
            <v-row>
                <v-col cols="12" md="12" class="d-flex px-0">
                    <v-text-field
                            v-model="filterForm.keyword"
                            class="search-name-contact pt-0"
                            placeholder="Tìm theo SĐT, mã đơn, namecode, giá trị tiền, mã phiếu thu"
                            clearable
                            @keyup.enter="searchContact"
                            style="margin-top: -26px; margin-right: 30px;"
                    />
                    <div class="group-btn-search">
                        <v-menu
                                :internal-activator="true"
                                v-model="filterForm.closeMenu"
                                content-class="menu__customer no-contain overflow-visible"
                                :close-on-content-click="false"
                        >
                            <template v-slot:activator="menuON">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                                icon
                                                medium
                                                color="white"
                                                v-on="on"
                                                class="search-contact--dropdown"
                                                @click="searchContact"
                                        >
                                            <v-icon size="20"
                                                    v-on="menuON.on"
                                            >mdi-chevron-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Tìm kiếm nâng cao</span>
                                </v-tooltip>
                            </template>
                            <card-filter-form
                                    :filterForm="filterForm"
                                    :banks="banks"
                            />
                        </v-menu>
                        <v-btn class="search-contact--text" small color="primary mx-0" @click="searchContact">
                             <span class="mr-3">Tìm kiếm</span>
                        </v-btn>
                    </div>
                </v-col>
                <!-- -->
            </v-row>
        </v-list-item-content>
    </v-list-item>
</template>
<script>
    import CardFilterForm from './CardFilterForm';
    export default {
        components: { CardFilterForm },
        props: {
            filterForm: {
                default: () => ({})
            },
            banks: {
                  default: () => []
            },
        },
        methods: {
            searchContact() {
                if(this.filterForm?.keyword?.length > 30){
                  return
                }
                Bus.$emit('contact-list-filter', this.filterForm);
            },
        },
    };
</script>
<style scoped>
    /deep/.m--contact-assignedAt .daterangepicker.openscenter {
        left: calc(50% + 100px) !important;
    }
    /deep/.m--contact-appointmentAt .daterangepicker.openscenter {
        left: 0 !important;
    }
    .group-btn-search {
        position: absolute;
        top: 8px;
        right: 0px;
        max-width: 130px;
    }
    .group-btn-search .search-contact--dropdown{
        position: absolute;
        right: -10px;
        z-index: 1;
        top: -7px;
    }
    .menu__customer {
        top: calc(20% - 75px) !important;
        left: 96% !important;
        transform: translateX(-96%) !important;
    }
    /deep/.search-name-contact .v-input__slot{
        width: calc(95% - 50px);
    }
    /deep/.search-name-contact input{
        font-size: 13px !important;
    }
</style>
